import React from 'react';

export const TotalMinutesByDay = React.createContext<Record<string, number> | null>(null);
